import React, { useState, useEffect } from 'react';
import Api from "../../services/Api";
import Header from "../../components/header/Header";

interface Props {
  login: Function
}

const Login: React.FC<Props> = (props) => {
  const api = Api.getInstance();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("")


  const submit = () => {
    setError("")
    const data = {
      email: email,
      password: password
    }
    api.post('login', data, ["bad_email", "bad_password"]).then(response => {
      if (response.json.token) {
        api.login(response.json)
        props.login()
      }
    }).catch(error => {
      if (error.isExpectedError) {
        if (error.errorName === 'bad_email') {
          setError("Vi kan inte hitta din mejladress. Kontakta support.")
        } else if (error.errorName === 'bad_password') {
          setError("Felaktigt lösenord. Prova igen?")
        }
      }
      console.log(error)
    })
  }

  return (
    <>
      <Header breadcrumbs={[{name: "Logga in"}]}/>
      <div className="page">
        <div className="content">
          <div className="mt-4 p-4 bg-my-green rounded-lg text-white">
            <div>
              Mejladdress:
            </div>

            <div>
              <input type="text" value={email} placeholder="Mejladress"  className="my-input"
                     onChange={(e) => setEmail(e.target.value)}/>
            </div>

            <div className="mt-4">
              Lösenord:
            </div>

            <div>
              <input type="password" value={password} placeholder="Lösenord" className="my-input"
                     onChange={(e) => setPassword(e.target.value)}/>
            </div>

            {
              error.length > 0 &&
                <div className="mt-4 border border-red-800 p-4 rounded-lg">
                  {error}
                </div>
            }

            <button className="mt-4 my-button w-full" onClick={() => submit()}>Logga in</button>
          </div>
        </div>
      </div>
    </>

  )
}

export default Login